import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TempleTimingsTable() {
  const [data, setData] = useState([]);

  const [editingHeadingId, setEditingHeadingId] = useState(null);
  const [headingValue, setHeadingValue] = useState("");

  const [editingTimingId, setEditingTimingId] = useState(null);
  const [timeValue, setTimeValue] = useState("");

  /* ---------------- LOAD DATA ---------------- */

  const loadData = async () => {
    const res = await axios.get(
      "https://atblogin.cubixsystems.com/myapp/api/fetch_timings.php"
    );
    setData(res.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  /* ---------------- STATUS UPDATE ---------------- */

  const updateStatus = async (id, status) => {
    await axios.post(
      "https://atblogin.cubixsystems.com/myapp/api/toggle_status.php",
      { id, status }
    );
    loadData();
  };

  /* ---------------- HEADING ---------------- */

  const updateHeading = async (id) => {
    await axios.post(
      "https://atblogin.cubixsystems.com/myapp/api/update_heading.php",
      { id, heading: headingValue }
    );
    setEditingHeadingId(null);
    loadData();
  };

  const deleteHeading = async (id) => {
    if (!window.confirm("Delete this heading?")) return;
    await axios.post(
      "https://atblogin.cubixsystems.com/myapp/api/delete_heading.php",
      { id }
    );
    loadData();
  };

  /* ---------------- TIMING ---------------- */

  const updateTiming = async (id) => {
    await axios.post(
      "https://atblogin.cubixsystems.com/myapp/api/update_timing.php",
      { id, time_value: timeValue }
    );
    setEditingTimingId(null);
    loadData();
  };

  return (
    <div classname="container" style={{height:'70vh',overflow:'auto'}}>
    <table className="table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Timings</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {data.map((row) => {
          const status = Number(row.status); // 🔥 IMPORTANT
          const isDisabled = status === 0;

          return (
            <tr
              key={row.id}
              style={{
                backgroundColor: isDisabled ? "#f8d7da" : "#ffffff",
                color: isDisabled ? "#721c24" : "#000"
              }}
            >
              {/* ---------------- HEADING ---------------- */}
              <td>
                {editingHeadingId === row.id ? (
                  <>
                    <textarea className="form-control" style={{height:'150px',fontSize:'11pt',color:'black'}}
                      value={headingValue}
                      onChange={(e) => setHeadingValue(e.target.value)}
                    ></textarea>
                    <button onClick={() => updateHeading(row.id)} className="btn btn-success">✔</button>
                    <button onClick={() => setEditingHeadingId(null)} className="btn btn-secondary">✖</button>
                  </>
                ) : (
                  <>
                    <strong>{row.heading}</strong>
                    <button className="btn" style={{marginLeft:'6px',background:'#004962ff',color:'white',cursor:'pointer'}}
                      onClick={() => {
                        setEditingHeadingId(row.id);
                        setHeadingValue(row.heading);
                      }}
                    >
                     <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>
                  </>
                )}
              </td>

              {/* ---------------- TIMINGS ---------------- */}
              <td>
                {/* <b>🌅 Morning</b> */}
                {row.morning.map((m) => (
                  <div key={m.id}>
                    {editingTimingId === m.id ? (
                      <>
                        <textarea className="form-control" style={{height:'150px',fontSize:'10pt',color:'black'}}
                          value={timeValue}
                          onChange={(e) => setTimeValue(e.target.value)}
                        ></textarea>
                        <button onClick={() => updateTiming(m.id)} className="btn btn-success">✔</button>
                        <button onClick={() => setEditingTimingId(null)} className="btn btn-secondary">✖</button>
                      </>
                    ) : (
                      <>
                        {m.time_value}
                        <button  className="btn" style={{marginLeft:'6px',background:'#004962ff',color:'white',cursor:'pointer'}}
                          onClick={() => {
                            setEditingTimingId(m.id);
                            setTimeValue(m.time_value);
                          }}
                        >
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </button>
                      </>
                    )}
                  </div>
                ))}

                {/* <b>🌇 Evening</b> */}
                {/* {row.evening.map((e) => (
                  <div key={e.id}>
                    {editingTimingId === e.id ? (
                      <>
                        <input
                          value={timeValue}
                          onChange={(ev) => setTimeValue(ev.target.value)}
                        />
                        <button onClick={() => updateTiming(e.id)}>✔</button>
                        <button onClick={() => setEditingTimingId(null)}>✖</button>
                      </>
                    ) : (
                      <>
                        {e.time_value}
                        <button
                          style={{ marginLeft: 6 }}
                          onClick={() => {
                            setEditingTimingId(e.id);
                            setTimeValue(e.time_value);
                          }}
                        >
                          ✏
                        </button>
                      </>
                    )}
                  </div>
                ))} */}
              </td>

              {/* ---------------- STATUS ---------------- */}
              <td>
                <strong>
                  {status === 1 ? "Enabled" : "Disabled"}
                </strong>

                <br />

                <button
                  style={{
                    marginTop: 6,
                    marginRight: 6,
                    background: "#28a745",
                    color: "#fff",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                    opacity: status === 1 ? 0.5 : 1
                  }}
                  disabled={status === 1}
                  onClick={() => updateStatus(row.id, 1)}
                >
                  <i class="fa fa-play" aria-hidden="true"></i>
                  {/* Enable */}
                </button>

                <button
                  style={{
                    marginTop: 6,
                    background: "#dc3545",
                    color: "#fff",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                    opacity: status === 0 ? 0.5 : 1
                  }}
                  disabled={status === 0}
                  onClick={() => updateStatus(row.id, 0)}
                >
                  <i class="fa fa-pause" aria-hidden="true"></i>
                  {/* Disable */}
                </button>
              </td>

              {/* ---------------- ACTIONS ---------------- */}
              <td>
                <button onClick={() => deleteHeading(row.id)} className="btn btn-danger">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
}
